import routes from '@/routers/routes';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // ブラウザの戻る/進むのときは前のスクロール位置を維持
    if (savedPosition) {
      return savedPosition;
    } else {
      // 通常のページ遷移時はトップに戻す
      return { top: 0 };
    }
  },
});

export default router;
